const getFinsightModalForm = (state) => state.modalForm;

export const isFetching = (state) => getFinsightModalForm(state).isFetching;
export const isSubmitSucceed = (state) => getFinsightModalForm(state).isSubmitSucceed;
export const isCorrectionModalVisible = (state) => getFinsightModalForm(state).isCorrectionModalVisible;
export const isMissingSomethingModalVisible = (state) => getFinsightModalForm(state).isMissingSomethingModalVisible;
export const getFinsightModalFormError = (state) => getFinsightModalForm(state).error;
